// extracted by mini-css-extract-plugin
module.exports = {"viewTrailerButtonFrame":"Cb","viewTrailerButton":"Cc","cta":"Cd","trailerIcon":"Ce"};